import apiClient from 'utilities/apiClient';

export const get_all_emp_tasks = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.plans}/${url}`, payload, true);
};

export const release_task = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.plans}/${url}`, payload, true);
};

export const watch_task = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.plans}/${url}`, payload, true);
};
